// extracted by mini-css-extract-plugin
export var banner = "_kh-0";
export var settingRow = "_kh-2";
export var titleIcon = "_kh-1";